export default async function CopySource(source: string): Promise<void> {
    await navigator.clipboard.writeText(source)
}
